import { AuthenticationService } from '../../shared/services/authentication.service';
import { SitesService } from '../../shared/services/sites.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardUtils } from '../../shared/DashboardUtils';
import { timer, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-dashboard-site-page',
    templateUrl: './dashboard-site-page.component.html',
    styleUrls: ['./dashboard-site-page.component.css']
})
export class DashboardSitePageComponent implements OnInit, OnDestroy {

    private templateCardDemanda = { tags: [], getIconClass: () => "image-demanda", iconWidth: "26px", getLabel: () => "DEMANDA", getValue: () => { }, isClickable: false, onClick: () => { } };
    private templateCardTensao = { tags: [], getIconClass: () => "image-tensao", iconWidth: "20px", getLabel: () => "TENSÃO DA BARRA", getValue: () => { }, isClickable: false, onClick: () => { } };
    private templateCardGeradores = { tags: [], getIconClass: () => "image-gerador-on", iconWidth: "41px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardChillers = { tags: [], getIconClass: () => "image-chiller-on", iconWidth: "32px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardConcessionaria = { tags: [], getIconClass: () => "image-concessionaria-on", iconWidth: "55px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardCaldeiras = { tags: [], getIconClass: () => "image-caldeira-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_PS = { tags: [], getIconClass: () => "image-ps-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_BC = { tags: [], getIconClass: () => "image-bc-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_BD = { tags: [], getIconClass: () => "image-bd-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_SE = { tags: [], getIconClass: () => "image-se-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_PC = { tags: [], getIconClass: () => "image-pc-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_PN = { tags: [], getIconClass: () => "image-pn-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_CH = { tags: [], getIconClass: () => "image-ch-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_GR = { tags: [], getIconClass: () => "image-gr-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_AC = { tags: [], getIconClass: () => "image-ac-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_BM = { tags: [], getIconClass: () => "image-bm-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_TB = { tags: [], getIconClass: () => "image-tb-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_CA = { tags: [], getIconClass: () => "image-ca-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_CC = { tags: [], getIconClass: () => "image-cc-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_PR = { tags: [], getIconClass: () => "image-pr-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_MN = { tags: [], getIconClass: () => "image-mn-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_OP = { tags: [], getIconClass: () => "image-op-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_BA = { tags: [], getIconClass: () => "image-ba-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_TT = { tags: [], getIconClass: () => "image-tt-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_EM = { tags: [], getIconClass: () => "image-em-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_SM = { tags: [], getIconClass: () => "image-sm-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_CO = { tags: [], getIconClass: () => "image-co-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardPlanta_EC = { tags: [], getIconClass: () => "image-ec-on", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };
    private templateCardGrafico = { tags: [], getIconClass: () => "iconegrafico", iconWidth: "25px", getLabel: () => { }, getValue: () => { }, isClickable: true, onClick: () => { } };


    public site: any;
    public realTimeCards: any[];
    public charts: any[];

    private refreshCardDataSubscription: Subscription;
    private refreshChartDataSubscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public authenticationService: AuthenticationService,
        private sitesService: SitesService,
        private dataService: DataService,
        private spinner: NgxSpinnerService) {
        this.realTimeCards = [];
        this.charts = [];
    }

    ngOnInit() {
        this.route.params.subscribe(params => {

            this.spinner.show();
            this.sitesService.get(params['id']).subscribe(response => {
                this.site = response;

                // 1. Card de Demanda (potência ativa)
                if (this.site.tagPotenciaAtivaDespacho && this.site.tagPotenciaAtivaDespacho.tagRealTimeValue) {
                    let cardDemanda = Object.assign({}, this.templateCardDemanda);
                    cardDemanda.tags.push({ tag: this.site.tagPotenciaAtivaDespacho.tagRealTimeValue });
                    cardDemanda.getValue = () => !isNaN(cardDemanda.tags[0].value) ? (cardDemanda.tags[0].value.toFixed(1) == -0 ? "0,0kW" : cardDemanda.tags[0].value.toFixed(1).replace(/[.]/, ",") + "kW") : "-";
                    this.realTimeCards.push(cardDemanda);
                }

                // 2. tensão                
                if (this.site.tagTensaoBarra && this.site.tagTensaoBarra.tagRealTimeValue) {
                    let cardTensao = Object.assign({}, this.templateCardTensao);
                    cardTensao.tags.push({ tag: this.site.tagTensaoBarra.tagRealTimeValue });
                    cardTensao.getValue = () => !isNaN(cardTensao.tags[0].value) ? (cardTensao.tags[0].value.toFixed(1) == -0 ? "0,0V" : cardTensao.tags[0].value.toFixed(1).replace(/[.]/, ",") + "V") : "-";
                    this.realTimeCards.push(cardTensao);
                }

                // 3. Cards dos Geradores
                if (this.site.grupoGeradores.length > 0) {
                    let cardGeradores = Object.assign({}, this.templateCardGeradores);

                    let statusTags = [];
                    let potenciaAtivaTags = [];
                    this.site.grupoGeradores[0].geradores.forEach(element => {
                        let statusTag = { tag: element.tagStatus.tagRealTimeValue };
                        statusTags.push(statusTag);
                        cardGeradores.tags.push(statusTag);

                        if (element.tagPotenciaAtiva && element.tagPotenciaAtiva.tagRealTimeValue) {
                            let potenciaAtivaTag = { tag: element.tagPotenciaAtiva.tagRealTimeValue };
                            potenciaAtivaTags.push(potenciaAtivaTag);
                            cardGeradores.tags.push(potenciaAtivaTag);
                        }
                    });
                    cardGeradores.getLabel = () => DashboardUtils.toStatusCountLabel(statusTags, "GERADORES");
                    cardGeradores.getValue = function () {
                        let total = 0;
                        potenciaAtivaTags.forEach(element => {
                            if (element.value) total += element.value;
                        });
                        return (total.toFixed(1) == "-0.0" ? "0,0kW" : total.toFixed(1).replace(/[.]/, ",") + "kW");
                        // return total.toFixed(1).replace(/[.]/, ",") + "kW";

                    };
                    cardGeradores.onClick = () => { this.router.navigate([`dashboard/${this.site.id}/grupo-geradores`]); };
                    this.realTimeCards.push(cardGeradores);
                }
                // 4. Card dos Chillers
                if (this.site.grupoChillers.length > 0) {
                    let cardChillers = Object.assign({}, this.templateCardChillers);
                    if (this.site.grupoChillers[0].tagGeracaoAguaGelada && this.site.grupoChillers[0].tagGeracaoAguaGelada.tagRealTimeValue) {
                        cardChillers.tags.push({ tag: this.site.grupoChillers[0].tagGeracaoAguaGelada.tagRealTimeValue });
                    }

                    this.site.grupoChillers[0].chillers.forEach(element => {
                        cardChillers.tags.push({ tag: element.tagStatus.tagRealTimeValue });
                    });
                    cardChillers.getLabel = () => DashboardUtils.toStatusCountLabel(this.site.grupoChillers[0].tagGeracaoAguaGelada && this.site.grupoChillers[0].tagGeracaoAguaGelada.tagRealTimeValue ? cardChillers.tags.slice(1) : cardChillers.tags, "CHILLERS");
                    cardChillers.getValue = () => this.site.grupoChillers[0].tagGeracaoAguaGelada && this.site.grupoChillers[0].tagGeracaoAguaGelada.tagRealTimeValue && !isNaN(cardChillers.tags[0].value) ? (cardChillers.tags[0].value.toFixed(1) == -0 ? "0,0TR" : cardChillers.tags[0].value.toFixed(1).replace(/[.]/, ",") + "TR") : "-";
                    cardChillers.onClick = () => { this.router.navigate([`dashboard/${this.site.id}/grupo-chillers`]); };
                    this.realTimeCards.push(cardChillers);
                }

                // 5. Cards das Concessionarias
                this.site.concessionarias.forEach(concessionaria => {
                    let cardConcessionaria = Object.assign({}, this.templateCardConcessionaria);
                    if (concessionaria.tagPotenciaAtiva && concessionaria.tagPotenciaAtiva.tagRealTimeValue) {
                        // cardConcessionaria.tags.push({ tag: concessionaria.tagPotenciaAtiva.tagRealTimeValue });
                        cardConcessionaria.tags = [{ tag: concessionaria.tagPotenciaAtiva.tagRealTimeValue }];
                    }
                    cardConcessionaria.getLabel = () => concessionaria.name;
                    cardConcessionaria.getValue = () => cardConcessionaria.tags.length == 0 ? '-' : !isNaN(cardConcessionaria.tags[0].value) ? (cardConcessionaria.tags[0].value.toFixed(1) == -0 ? "0,0kW" : cardConcessionaria.tags[0].value.toFixed(1).replace(/[.]/, ",") + "kW") : "-";
                    cardConcessionaria.onClick = () => { this.router.navigate([`dashboard/${this.site.id}/concessionaria/${concessionaria.id}`]); };
                    this.realTimeCards.push(cardConcessionaria);
                });

                // 6. Card das Caldeiras
                if (this.site.grupoCaldeiras.length > 0) {
                    let grupoCaldeiras = this.site.grupoCaldeiras[0];
                    let cardCaldeiras = Object.assign({}, this.templateCardCaldeiras);
                    if (grupoCaldeiras.tagGeracaoVapor && grupoCaldeiras.tagGeracaoVapor.tagRealTimeValue) {
                        cardCaldeiras.tags.push({ tag: grupoCaldeiras.tagGeracaoVapor.tagRealTimeValue });
                    }

                    grupoCaldeiras.caldeiras.forEach(element => {
                        cardCaldeiras.tags.push({ tag: element.tagStatus.tagRealTimeValue });
                    });

                    cardCaldeiras.getLabel = () => DashboardUtils.toStatusCountLabel(grupoCaldeiras.tagGeracaoVapor && grupoCaldeiras.tagGeracaoVapor.tagRealTimeValue ? cardCaldeiras.tags.slice(1) : cardCaldeiras.tags, "CALDEIRAS");
                    cardCaldeiras.getValue = () => grupoCaldeiras.tagGeracaoVapor && grupoCaldeiras.tagGeracaoVapor.tagRealTimeValue && !isNaN(cardCaldeiras.tags[0].value) ? (cardCaldeiras.tags[0].value.toFixed(1) == -0 ? "0,0T/h" : cardCaldeiras.tags[0].value.toFixed(1).replace(/[.]/, ",") + "T/h") : '-';
                    cardCaldeiras.onClick = () => { this.router.navigate([`dashboard/${this.site.id}/grupo-caldeiras`]); };
                    this.realTimeCards.push(cardCaldeiras);
                }

                // // 5. Cards das Concessionarias
                // this.site.concessionarias.forEach(concessionaria => {
                //     let cardConcessionaria = Object.assign({}, this.templateCardConcessionaria);
                //     if (concessionaria.tagPotenciaAtiva && concessionaria.tagPotenciaAtiva.tagRealTimeValue) {
                //         // cardConcessionaria.tags.push({ tag: concessionaria.tagPotenciaAtiva.tagRealTimeValue });
                //         cardConcessionaria.tags = [{ tag: concessionaria.tagPotenciaAtiva.tagRealTimeValue }];
                //     }
                //     cardConcessionaria.getLabel = () => concessionaria.name;
                //     cardConcessionaria.getValue = () => cardConcessionaria.tags.length == 0 ? '-' : !isNaN(cardConcessionaria.tags[0].value) ? (cardConcessionaria.tags[0].value.toFixed(1) == -0 ? "0,0kW" : cardConcessionaria.tags[0].value.toFixed(1).replace(/[.]/, ",") + "kW") : "-";
                //     cardConcessionaria.onClick = () => { this.router.navigate([`dashboard/${this.site.id}/concessionaria/${concessionaria.id}`]); };
                //     this.realTimeCards.push(cardConcessionaria);
                // });


                // 1. Gráfico de Demanda
                if (this.site.tagPotenciaAtivaDespacho && this.site.tagPotenciaAtivaDespacho.tagHistoricalValues) {
                    let chartDemanda = DashboardUtils.buildDefaultChart("Demanda (kW)", this.site.tagPotenciaAtivaDespacho);
                    this.updateChart(chartDemanda);
                    this.charts.push(chartDemanda);
                }

                // 2. Gráfico de Geração de Vapor (Caldeiras)
                if (this.site.grupoCaldeiras.length > 0 && this.site.grupoCaldeiras[0].tagGeracaoVapor && this.site.grupoCaldeiras[0].tagGeracaoVapor.tagHistoricalValues) {
                    let chartGeracaoVapor = DashboardUtils.buildDefaultChart("Geração de Vapor (T/h)", this.site.grupoCaldeiras[0].tagGeracaoVapor);
                    this.updateChart(chartGeracaoVapor);
                    this.charts.push(chartGeracaoVapor);
                }

                // 3. Gráfico de Geração de Água Gelada (Chillers)
                if (this.site.grupoChillers.length > 0 && this.site.grupoChillers[0].tagGeracaoAguaGelada && this.site.grupoChillers[0].tagGeracaoAguaGelada.tagHistoricalValues) {
                    let chartGeracaoAguaGelada = DashboardUtils.buildDefaultChart("Geração de Água Gelada (TR)", this.site.grupoChillers[0].tagGeracaoAguaGelada);
                    this.updateChart(chartGeracaoAguaGelada);
                    this.charts.push(chartGeracaoAguaGelada);
                }

                this.refreshCardDataSubscription = timer(0, environment.dashboard.cardUpdatePeriodSeconds * 1000).subscribe(result => {
                    this.refreshCardData();
                });

                this.refreshChartDataSubscription = timer(0, environment.dashboard.chartUpdatePeriodSeconds * 1000).subscribe(result => {
                    this.refreshChartData();
                });


                //TRATAMENTO AGRUPAMENTOS GENERICOS - Mauricio Segura - 04/09/2025
                // this.site.grupoGenericos;
                // Tipos conhecidos  
                const tipos = ["PS", //Usina Solar
                    "CH", //Chiller
                    "GR", //Gerador
                    "AC", //Ar Condicionado
                    "BC", //Bomba de Calor
                    "BD", //BioGas
                    "BM", //BioMassa
                    "TB", //Turbina
                    "CA", //Caldeira
                    "CC", //Concessionaria
                    "SE", //Subestação
                    "PC", //Planta CO2
                    "PN", //Planta N2
                    "PR", //Processo
                    "MN", //Manutenção
                    "OP", //Operacional
                    "BA",  //Bateria
                    "TT",  //Totalizadores
                    "EM",  //Estação meteorológica
                    "SM",  //Sistema Elétrico
                    "CO",  //Cogeracao
                    "EC"   //Emissoes de CO2
                ]

                // Inicializa no objeto site com arrays vazios
                tipos.forEach(tipo => {
                    this.site[tipo] = [];
                });

                // Preenche com base no grupoGenericos
                this.site.siteGenericos.forEach(item => {
                    if (this.site[item.tipoEquipamento]) {
                        this.site[item.tipoEquipamento].push(item);
                    }
                });

                // RENDERIZAÇÃO DOS COMPONENTES GENERICOS - MAURICIO SEGURA - SETEMBRO/2025
                var configCards = [
                    { tipo: "PS", label: "USINA SOLAR", rota: "grupo-ps" },
                    { tipo: "BC", label: "BOMBA DE CALOR", rota: "grupo-ps" },
                    { tipo: "CH", label: "CAG", rota: "grupo-ps" },
                    { tipo: "GR", label: "GERADOR", rota: "grupo-ps" },
                    { tipo: "BD", label: "BIOGÁS", rota: "grupo-ps" },
                    { tipo: "AC", label: "AR CONDICIONADO", rota: "grupo-ps" },
                    { tipo: "BM", label: "BIOMASSA", rota: "grupo-ps" },
                    { tipo: "TB", label: "TURBNOGERADOR", rota: "grupo-ps" },
                    { tipo: "CA", label: "CALDEIRA", rota: "grupo-ps" },
                    { tipo: "CC", label: "CONCESSIONARIA", rota: "grupo-ps" },
                    { tipo: "SE", label: "SUBSTAÇÃO", rota: "grupo-ps" },
                    { tipo: "PC", label: "PLANTA CO2", rota: "grupo-ps" },
                    { tipo: "PN", label: "PLANTA N2", rota: "grupo-ps" },
                    { tipo: "PR", label: "PROCESSO", rota: "grupo-ps" },
                    { tipo: "MN", label: "MANUTENÇÃO", rota: "grupo-ps" },
                    { tipo: "OP", label: "OPERACIONAL", rota: "grupo-ps" },
                    { tipo: "BA", label: "BATERIAS", rota: "grupo-ps" },
                    { tipo: "TT", label: "TOTALIZADORES", rota: "grupo-ps" },
                    { tipo: "EM", label: "ESTAÇÃO METEOROLÓGICA", rota: "grupo-ps" },
                    { tipo: "SM", label: "SISTEMA ELÉTRICO", rota: "grupo-ps" },
                    { tipo: "CO", label: "COGERAÇÃO", rota: "grupo-ps" },
                    { tipo: "EC", label: "EMISSÕES DE CO2", rota: "grupo-ps" }
                ];

                configCards.forEach(cfg =>
                    this.criarCardPlanta(cfg.tipo, cfg.label, cfg.rota)
                );

                // Agora sempre terá todos os arrays
                //console.log(equipamentosPorTipo.PS);    // pode ter itens ou []
                //console.log(equipamentosPorTipo.INV);   // pode ter itens ou []
                //console.log(equipamentosPorTipo.MT);    // pode ter itens ou []

                //TRATAMENTO GRAFICOS - MAURICIO SEGURA (06/02/2026)
                if (this.site && this.site.siteGraficos && Array.isArray(this.site.siteGraficos) && this.site.siteGraficos.length > 0) {
                    this.criarCardGrafico('dash', 'Graficos', '')
                }

                this.spinner.hide();
            });
        });
    }

    criarCardGrafico(tipo: string,            // Ex: "BC", "CH"
        label: string,           // Ex: "BOMBA DE CALOR"
        rota: string             // Ex: "grupo-bc"
    ) {

        // Monta o nome da variável do template dinamicamente
        const templateKey = `templateCardGrafico`;
        const template = this[templateKey];

        if (!template) {
            console.warn(`Template não encontrado para tipo: ${tipo}`);
            return;
        }

        let card = Object.assign({}, template);
        card.getLabel = () =>
            'GRÁFICOS'
        //DashboardUtils.toStatusCountLabel(card.tags, label);

        card.getIconClass = () => "iconegrafico"

        card.onClick = () => {
            this.router.navigate([`dashboard/${this.site.id}/graficos`]);
        };

        this.realTimeCards.push(card);
    }
    criarCardPlanta(
        tipo: string,            // Ex: "BC", "CH"
        label: string,           // Ex: "BOMBA DE CALOR"
        rota: string             // Ex: "grupo-bc"
    ) {
        const lista = this.site[tipo]; // Pega a lista da planta
        if (!lista || lista.length === 0) return;

        // Monta o nome da variável do template dinamicamente
        const templateKey = `templateCardPlanta_${tipo}`;
        const template = this[templateKey];

        if (!template) {
            console.warn(`Template não encontrado para tipo: ${tipo}`);
            return;
        }

        let card = Object.assign({}, template);

        lista.forEach(element => {
            card.tags.push({ tag: element.var_status });
        });

        card.getLabel = () =>
            label
        //DashboardUtils.toStatusCountLabel(card.tags, label);

        card.onClick = () => {
            this.router.navigate([`dashboard/${tipo + this.site.id}/${rota}`]);
        };

        this.realTimeCards.push(card);
    }


    ngOnDestroy() {
        if (this.refreshCardDataSubscription) this.refreshCardDataSubscription.unsubscribe();
        if (this.refreshChartDataSubscription) this.refreshChartDataSubscription.unsubscribe();
    };

    refreshCardData() {
        var tags = [];
        this.realTimeCards.forEach(c => tags = tags.concat(c.tags));
        this.dataService.read({ items: tags }).subscribe(response => {
            for (let i in response.data) {
                Object.assign(tags[i], response.data[i]);
            }
        });
    };

    refreshChartData() {
        this.charts.forEach(chart => {
            this.updateChart(chart);
        });
    };

    updateChart(chartToUpdate) {
        DashboardUtils.updateChart(this.dataService, chartToUpdate);
    };
}